/**
 * Used so that the FontFamilyFontStyles component can make anchor links to the specimens.
 */
export default function getTypeEditorId(fontStyleName: string): string {
    return `spc-${fontStyleName.replaceAll(' ', '-').toLowerCase()}`;
}
